import { Text, TouchableOpacity, View } from 'react-native';
import React, { FC } from 'react';
import { Image } from '../components/Image';
import { NavigationService } from '../services/navigation';
import { useSelector } from 'react-redux';
import { RootState } from '../services/redux';
import { COLORS, FONTS } from '../constants';

const HeaderMobileRight: FC = () => {
  const auth = useSelector((redux: RootState) => redux.authReducer);
  const { itemNum } = useSelector((redux: RootState) => redux.cartReducer);

  if (!auth.loggedin) return <></>;

  return (
    <View style={{ flexDirection: 'row', alignItems: 'center', gap: 20 }}>
      <TouchableOpacity
        onPress={() => {
          NavigationService.navigate<'Notices'>('Notices', {
            screen: 'new',
          });
        }}
      >
        <Image
          source={require('../assets/notices.png')}
          style={{
            width: 25,
            height: 25,
            tintColor: 'white',
            resizeMode: 'contain',
          }}
        />
      </TouchableOpacity>
      <TouchableOpacity
        onPress={() => {
          NavigationService.navigate('EShopCheckout');
        }}
      >
        <Image
          source={require('../assets/cart.png')}
          style={{ width: 30, height: 30, marginLeft: 10, tintColor: 'white' }}
        />
        <View
          style={{
            position: 'absolute',
            top: -5,
            right: 0,
            width: 20,
            height: 20,
            backgroundColor: 'red',
            justifyContent: 'center',
            flexDirection: 'row',
            alignItems: 'center',
            borderRadius: 10,
          }}
        >
          <Text
            style={{
              fontFamily: FONTS.AvenirMedium,
              fontSize: 12,
              color: COLORS.WHITE,
              textAlign: 'center',
            }}
          >
            {itemNum}
          </Text>
        </View>
      </TouchableOpacity>
    </View>
  );
};

export default HeaderMobileRight;
